import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
    adminApiUrl,
    getUserCredentials
} from "../../axiosUtils"
import { DeviceEmailId, FrecuencyEmailId, ScheduleEmail } from "../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice"
import { Schedule } from "../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice"


type GetScheduleData = {
    results: ScheduleEmail[]
    countActivated: number
    countDeactivated: number
}

export const getScheduleEmails = (activated: number) => {
    return new Promise((resolve: (value: GetScheduleData) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                params: { activated }
            };
            axios.get(`${adminApiUrl}/v1/user/emails/schedule`,  config)
            .then((res) => {resolve(res.data)})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const deleteScheduleEmails = (id: string) => {
    return new Promise((resolve: (value: ScheduleEmail[]) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.delete(`${adminApiUrl}/v1/user/emails/schedule/${id}`,  config)
            .then((res) => {resolve(res.data.results)})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule/${id}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 

export type BodyScheduleEmails = {
    bodyEmail:      string
    topic:          string
    schedule:       Schedule
    subject:        string
    frecuency:      FrecuencyEmailId
    device:         DeviceEmailId
}

export const createScheduleEmail = (body: BodyScheduleEmails) => {
    return new Promise((resolve, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                timeout: 20000
            };
            axios.post(`${adminApiUrl}/v1/user/emails/schedule`, body, config)
            .then((res) => {resolve("ok")})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const getScheduleEmail = (id: string) => {
    return new Promise((resolve: (value: ScheduleEmail) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.get(`${adminApiUrl}/v1/user/emails/schedule/${id}`,  config)
            .then((res) => {resolve(res.data.Item)})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule/${id}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 

export const activateScheduleEmail = (id: string) => {
    return new Promise((resolve: (value: ScheduleEmail[]) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.patch(`${adminApiUrl}/v1/user/emails/schedule/${id}/activate`, {},  config)
            .then((res) => {resolve(res.data.results)})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule/${id}/activate`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
}


export const deactivateScheduleEmail = (id: string) => {
    return new Promise((resolve: (value: ScheduleEmail[]) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.patch(`${adminApiUrl}/v1/user/emails/schedule/${id}/deactivate`, {},  config)
            .then((res) => {resolve(res.data.results)})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule/${id}/deactivate`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
}

export type UpdateScheduleEmailBody = {
    bodyEmail:                string
    topic:                    string
    subject:                  string
    schedule:                 Schedule
    frecuency:                FrecuencyEmailId
    device:                   DeviceEmailId
}

export const updateScheduleEmail = (id: string, body: UpdateScheduleEmailBody) => {
    return new Promise((resolve: (value: string) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };
            axios.patch(`${adminApiUrl}/v1/user/emails/schedule/${id}`, body,  config)
            .then((res) => {resolve("Ok")})
            .catch((error) => { 
                console.log("Error: ", `${adminApiUrl}/v1/user/emails/schedule/${id}`, error); 
                console.log("E---rror", error)
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
}